<template>
  <path fill="currentColor" d="M75.7 23.2c-.2-2.4-.2-4.7-.2-7a3.2 3.2 0 0 0-3.2-3.2A43.2 43.2 0 0 1 40.1 1a3.3 3.3 0 0 0-4.5 0A43.2 43.2 0 0 1 3.4 13a3.2 3.2 0 0 0-3.2 3.3l-.1 6.9c-.4 22.6-1 53.6 36.7 66.6l1 .2 1.1-.2c37.7-13 37.2-44 36.8-66.6ZM35.3 54.5a3.5 3.5 0 0 1-2.3.8 3 3 0 0 1-2.3-1l-10-11.1 4.8-4.3 7.9 8.7L50.8 31l4.4 4.8Z"/>
</template>
